import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations, currentLang, customLabel } from "../i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(currentLang);
    const mode = lang;

    const setLang = useCallback((code) => {
        try { localStorage.setItem("lang", code); } catch { /* ignore */ }
        setLangState(code);
    }, []);
    useEffect(() => { document.documentElement.lang = lang; document.title = translations[lang].app_title; }, [lang]);

    const t = useCallback((key, vars) => {
        const dict = translations[lang] || translations.en;
        let s = customLabel(key) ?? dict[key] ?? translations.en[key] ?? key;
        if (vars) Object.keys(vars).forEach((k) => { s = s.split(`{${k}}`).join(String(vars[k])); });
        return s;
    }, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, mode, setLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useI18n() {
    return useContext(LanguageContext);
}
